import { render, staticRenderFns } from "./ViewPageNotFound.vue?vue&type=template&id=47553728&scoped=true&"
import script from "./ViewPageNotFound.vue?vue&type=script&lang=js&"
export * from "./ViewPageNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47553728",
  null
  
)

export default component.exports